import React from "react";
// nodejs library that concatenates classes
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardDeck,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";
import Iframe from "react-iframe-click";

// index page sections
import CardsFooter from "../components/Footers/CardsFooter";
import classnames from "classnames";
import { members } from "../data/members";
import MemberCard from "../components/MemberCard/MemberCard";
import "./Landing.css";
import HSLogo from "../assets/img/brand/HubSpotLogo.png";
import BBLogo from "../assets/img/brand/BloombergLogo.png";
import OptLogo from "../assets/img/brand/optiverlogo.png";
import SIGLogo from "../assets/img/brand/SIGlogo.png";

class Landing extends React.Component {
  state = {};

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.setState({ containerWidth: this.ref.current.offsetWidth });
    this.refs.main.scrollTop = 0;
  }

  chunkArrayInGroups(arr, size) {
    var myArray = [];
    for (var i = 0; i < arr.length; i += size) {
      myArray.push(arr.slice(i, i + size));
    }
    return myArray;
  }

  render() {
    // @ts-ignore
    return (
      <>
        <MainNavbar />
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default"></div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Women and Non-Binary Individuals in Computing{" "}
                        <span>Imperial College London</span>
                      </h1>
                      <p className="lead text-white">
                        Welcome to Imperial Women and Non-Binary Individuals in
                        Computing! We are a collective of <b>students</b> and
                        researchers here in the Department of Computing
                        dedicated to <b>promoting initiatives</b> that aim to
                        tackle the <b>gender imbalance</b> in computer science,
                        as well as foster a community within the department that
                        is welcoming of <b>everyone</b>, regardless of gender.
                      </p>
                    </Col>
                    <Col lg={"4"}>
                      {window.innerWidth > 560 && (
                        <img
                          style={{ width: "100%", marginTop: "30px" }}
                          alt="..."
                          src={require("assets/img/brand/wicLogo.png")}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                      <Card
                        className="card-lift--hover shadow border-0"
                        style={{ height: "100%" }}
                      >
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-check-bold" />
                          </div>
                          <h6 className="text-primary text-uppercase">
                            Empower gender minorities
                          </h6>
                          <p className="description mt-3">
                            As a society, our main goal is to promote and
                            empower female and non-binary students in the
                            Department of Computing. We run a variety of events
                            aimed at undergraduate and postgraduate students,
                            such as industrial and academic careers talks as
                            well as social events that bring our community
                            together.
                          </p>

                          {/*<Button*/}
                          {/*    className="mt-4"*/}
                          {/*    color="primary"*/}
                          {/*    href="#pablo"*/}
                          {/*    onClick={e => e.preventDefault()}*/}
                          {/*>*/}
                          {/*    Learn more*/}
                          {/*</Button>*/}
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card
                        className="card-lift--hover shadow border-0"
                        style={{ height: "100%" }}
                      >
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="ni ni-check-bold" />
                          </div>
                          <h6 className="text-success text-uppercase">
                            Inspire the younger generation
                          </h6>
                          <p className="description mt-3">
                            Providing young girls and women with role models in
                            STEM that they can identify with is of the utmost
                            importance to us. We aim to run outreach initiatives
                            with local schools to encourage inspire the next
                            generation to pursue a career in STEM.
                          </p>
                          {/*<Button*/}
                          {/*    className="mt-4"*/}
                          {/*    color="success"*/}
                          {/*    href="#pablo"*/}
                          {/*    onClick={e => e.preventDefault()}*/}
                          {/*>*/}
                          {/*    Learn more*/}
                          {/*</Button>*/}
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card
                        className="card-lift--hover shadow border-0"
                        style={{ height: "100%" }}
                      >
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="ni ni-check-bold" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            Create an open and welcoming community
                          </h6>
                          <p className="description mt-3">
                            Our aim is to create a safe space where gender
                            minorities can come together to share their
                            experiences and discuss ways in which to improve the
                            gender disparity in computer science.
                          </p>
                          {/*<Button*/}
                          {/*    className="mt-4"*/}
                          {/*    color="warning"*/}
                          {/*    href="#pablo"*/}
                          {/*    onClick={e => e.preventDefault()}*/}
                          {/*>*/}
                          {/*    Learn more*/}
                          {/*</Button>*/}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg pt-0">
            <Container>
              <Card className="bg-gradient-primary shadow-lg border-0">
                <div className="p-5" ref={this.ref}>
                  <Row className="align-items-center">
                    <Col lg="8">
                      <h3 className="text-white">Join our Mailing List!</h3>
                      <p className="lead text-white mt-3">
                        Join our mailing list for exciting updates for our
                        events!
                      </p>
                    </Col>
                    <Col className="ml-lg-auto" lg="3">
                      <Button
                        block
                        className="btn-white"
                        color="default"
                        target={"_blank"}
                        href="http://eepurl.com/hpvHoT"
                        size="lg"
                      >
                        Subscribe
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Container>
          </section>
          <section className="section section-lg pt-0">
            <Container>
              <Row className="justify-content-center text-center">
                <Col lg="8">
                  <h2 className="display-3">Check out our Instagram!</h2>
                  <p
                    className="lead text-muted"
                    style={{ marginBottom: "30px" }}
                  >
                    See what we've been up to and follow for updates!
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center text-center" id={"test"}>
                <Col lg="12">
                  <script src={"https://snapwidget.com/js/snapwidget.js"} />
                  <div style={{ position: "relative" }}>
                    <div
                      id={"testDiv"}
                      onClick={() =>
                        window.open("https://www.instagram.com/wic_imperial/")
                      }
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    ></div>
                    <Iframe
                      src={"https://snapwidget.com/embed/988040"}
                      width={"100%"}
                      style={{ overflow: "hidden" }}
                      scrolling={"no"}
                      height={(this.state.containerWidth / 3) * 2}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section id={"committee"} className="section section-lg pt-0">
            <Container>
              <Row className="justify-content-center text-center">
                <Col lg="8">
                  <h2 className="display-3">Meet the Committee</h2>
                  <p className="lead text-muted">The 2023/24 WNBiC Committee</p>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                {this.chunkArrayInGroups(members, 4).map((i, cardIndex) => {
                  return (
                    <CardDeck key={cardIndex}>
                      {i.map((member, index) => {
                        return <MemberCard member={member} key={index}/>;
                      })}
                    </CardDeck>
                  );
                })}
              </Row>
            </Container>
          </section>
          <section id={"committee"} className="section section-lg pt-0">
            <Container>
              <Row className="justify-content-center text-center">
                <Col lg="8">
                  <h2 className="display-3" style={{ marginBottom: "50px" }}>
                    Our Sponsors
                  </h2>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="4">
                  <img
                    alt={"Bloomberg"}
                    onClick={() => window.open("https://www.bloomberg.com/uk")}
                    style={{ width: "100%", cursor: "pointer" }}
                    src={BBLogo}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="4">
                  <img
                    alt={"HubSpot"}
                    onClick={() => window.open("https://www.hubspot.com/")}
                    style={{ width: "100%", cursor: "pointer" }}
                    src={HSLogo}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg="4">
                  <img
                    alt={"Optiver"}
                    onClick={() => window.open("https://optiver.com/")}
                    style={{ width: "100%", cursor: "pointer" }}
                    src={OptLogo}
                  />
                </Col>
              </Row>

              <Row className="justify-content-center text-center">
                <Col lg="4">
                  <img
                    alt={"SIG"}
                    onClick={() => window.open("https://sig.com/")}
                    style={{ width: "100%", cursor: "pointer", marginTop: "50px"}}
                    src={SIGLogo}
                  />
                </Col>
              </Row>
            </Container>
          </section>
          <section
            id="contact"
            className="bg-primary"
            style={{ paddingBottom: "100px" }}
          >
            <Container className="pt-lg">
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Contact Us</h2>
                  <p className="lead text-white">
                    Use the contact form below to get in touch with us!
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="8">
                  <Card className="bg-gradient-secondary shadow">
                    <CardBody className="p-lg-5">
                      <h4 className="mb-1">Just fill out the form below!</h4>
                      <form
                        id="contactform"
                        action="https://formsubmit.io/send/ff1fab0a-a2bd-419b-b8ac-489d4d39c468"
                        method="POST"
                      >
                        <input
                          name="_formsubmit_id"
                          type="text"
                          style={{ display: "none" }}
                        />
                        <input
                          name="_redirect"
                          type="hidden"
                          id="name"
                          value="http://wic.doc.ic.ac.uk"
                        />
                        <FormGroup
                          className={classnames("mt-5", {
                            focused: this.state.nameFocused,
                          })}
                        >
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-circle-08" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Your name"
                              type="text"
                              name="name"
                              onFocus={(e) =>
                                this.setState({ nameFocused: true })
                              }
                              onBlur={(e) =>
                                this.setState({ nameFocused: false })
                              }
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup
                          className={classnames({
                            focused: this.state.emailFocused,
                          })}
                        >
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Email address"
                              type="email"
                              name="email"
                              onFocus={(e) =>
                                this.setState({ emailFocused: true })
                              }
                              onBlur={(e) =>
                                this.setState({ emailFocused: false })
                              }
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup className="mb-4">
                          <Input
                            className="form-control-alternative"
                            cols="80"
                            name="message"
                            placeholder="Type a message..."
                            rows="4"
                            type="textarea"
                          />
                        </FormGroup>
                        <div>
                          <Button
                            block
                            className="btn-round"
                            color="primary"
                            size="lg"
                            type="submit"
                          >
                            Send Message
                          </Button>
                        </div>
                      </form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default Landing;
